export const extractLanguageName = (language) => {
  if (!language) return '';
  
  // If language is an object with a name property
  const languageName = typeof language === 'string' 
    ? language 
    : language.name || '';
  
  // Extract just the language name before parentheses
  // Example: "C++ (GCC 9.2.0)" becomes "C++"
  const baseLanguageName = languageName.split('(')[0].trim();
  
  return baseLanguageName;
};

export const getMonacoLanguage = (language) => {
  if (!language) return 'plaintext';

  // Extract the base language name
  const baseLanguageName = extractLanguageName(language);
  const languageNameLower = baseLanguageName.toLowerCase();

  // Common language mapping
  const languageMap = {
    'c++': 'cpp',
    'c': 'c',
    'c#': 'csharp',
    'csharp': 'csharp',
    'java': 'java',
    'javafx': 'java', // Map JavaFX to Java
    'javascript': 'javascript',
    'js': 'javascript',
    'node.js': 'javascript',
    'python': 'python',
    'py': 'python',
    'ruby': 'ruby',
    'go': 'go',
    'golang': 'go',
    'php': 'php',
    'rust': 'rust',
    'kotlin': 'kotlin',
    'typescript': 'typescript',
    'ts': 'typescript',
    'html': 'html',
    'css': 'css',
    'sql': 'sql',
    'shell': 'shell',
    'bash': 'shell',
    'swift': 'swift',
    'scala': 'scala'
  };

  // Check exact matches first
  for (const [key, value] of Object.entries(languageMap)) {
    if (languageNameLower === key) {
      return value;
    }
  }

  // Then check if the language name contains any of the keys
  for (const [key, value] of Object.entries(languageMap)) {
    if (languageNameLower.includes(key)) {
      return value;
    }
  }

  // Default to plaintext for unknown languages
  return 'plaintext';
};
